import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import SessionInfo from '../session_info/SessionInfo';

import logo from './logo.svg';
import './Header.css';

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logged: false
    }

    this._handleOnLogin = this._handleOnLogin.bind(this);
    this._handleOnLogout = this._handleOnLogout.bind(this);
  }

  get sessionInfo() {
    return this._sessionInfo;
  }

  _handleOnLogin(event) {
    this.setState({ logged: true });
  }

  _handleOnLogout() {
    this.setState({ logged: false });
  }

  render() {
    return(
      <header className="header">
        <div className="header-logo">
          <NavLink to="/home">
            <img src={ logo } alt="STARLabs Support Portal"></img>
          </NavLink>
        </div>

        {/* LOGIN MENU */}
        <SessionInfo ref={ element => this._sessionInfo = element } 
          className="top-nav" 
          onLogin={ this._handleOnLogin } 
          onLogout={ this._handleOnLogout } />

        {/* NAVIGATION MENU */}
        <ul className="nav top-menu">

          <li className="nav-item">
            <NavLink to="/home" className="nav-link">Home</NavLink>
          </li>

          <li className="nav-item">
            <NavLink to="/provision-licensee" className="nav-link">Provision Licensee User Account</NavLink>
          </li>

          <li className="nav-item">
            <NavLink to="/provision-wb" className="nav-link">Provision WB User Account</NavLink>
          </li>

        {/*
          <li className="nav-item dropdown">
            <a href="#" className="nav-link" data-toggle="dropdown" aria-expanded="false">Logging <span className="caret"></span></a>

            <div className="dropdown-menu">
              <a href="" className="dropdown-item">Search by Task</a>
              <a href="" className="dropdown-item">Search by Transaction</a>
            </div>
          </li>
        */}
        </ul>
        <div className={ this.state.logged ? 'login-status logged' : 'login-status' }>
          <div className={ this.state.logged ? 'bg-success' : 'bg-danger'}></div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/_components/header/Header.jsx